import { Box } from '@mui/material';

const NOS = [
  { x: 90, y: 620 }, { x: 260, y: 480 }, { x: 210, y: 780 },
  { x: 480, y: 560 }, { x: 620, y: 340 }, { x: 850, y: 460 },
  { x: 1020, y: 260 }, { x: 1180, y: 560 }, { x: 1380, y: 380 },
  { x: 1550, y: 620 }, { x: 900, y: 720 }, { x: 1250, y: 200 },
];
const LIGACOES = [
  [0, 1], [1, 2], [1, 3], [3, 4], [4, 5], [5, 6], [6, 7], [7, 8],
  [8, 9], [3, 10], [10, 7], [6, 11], [8, 11],
];

export default function FundoTecnologico() {
  return (
    <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <Box sx={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(120% 90% at 15% 20%, #16406e 0%, #0b1a2e 45%, #050a12 100%)',
      }} />
      <Box sx={{
        position: 'absolute', width: 620, height: 620, borderRadius: '50%', top: '-12%', left: '-6%',
        background: 'radial-gradient(circle, rgba(233,69,96,0.28) 0%, transparent 70%)',
        filter: 'blur(10px)', animation: 'derivaA 16s ease-in-out infinite',
      }} />
      <Box sx={{
        position: 'absolute', width: 700, height: 700, borderRadius: '50%', bottom: '-18%', right: '-8%',
        background: 'radial-gradient(circle, rgba(8,145,178,0.22) 0%, transparent 70%)',
        filter: 'blur(10px)', animation: 'derivaB 20s ease-in-out infinite',
      }} />
      <Box sx={{
        position: 'absolute', width: 420, height: 420, borderRadius: '50%', top: '35%', left: '55%',
        background: 'radial-gradient(circle, rgba(19,55,95,0.35) 0%, transparent 70%)',
        filter: 'blur(10px)', animation: 'derivaA 22s ease-in-out infinite reverse',
      }} />
      <Box sx={{ position: 'absolute', inset: 0, perspective: '450px', overflow: 'hidden' }}>
        <Box sx={{
          position: 'absolute', bottom: 0, left: '-30%', width: '160%', height: '62%',
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.055) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.055) 1px, transparent 1px)
          `,
          backgroundSize: '54px 54px',
          transform: 'rotateX(68deg)', transformOrigin: 'bottom',
          animation: 'pisoMove 9s linear infinite',
          maskImage: 'linear-gradient(to top, black 0%, transparent 85%)',
          WebkitMaskImage: 'linear-gradient(to top, black 0%, transparent 85%)',
        }} />
      </Box>
      <Box
        component="svg" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice"
        sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0.75 }}
      >
        {LIGACOES.map(([a, b], i) => (
          <line
            key={`l${i}`}
            x1={NOS[a].x} y1={NOS[a].y} x2={NOS[b].x} y2={NOS[b].y}
            stroke="rgba(255,255,255,0.14)" strokeWidth="1"
          />
        ))}
        {NOS.map((n, i) => (
          <circle key={`n${i}`} cx={n.x} cy={n.y} r={i % 3 === 0 ? 4 : 2.5} fill="rgba(255,255,255,0.5)" />
        ))}
        {LIGACOES.map(([a, b], i) => (
          <circle key={`p${i}`} r="3.2" fill="#e94560">
            <animateMotion
              dur={`${5 + (i % 4)}s`}
              begin={`${i * 0.9}s`}
              repeatCount="indefinite"
              path={`M${NOS[a].x},${NOS[a].y} L${NOS[b].x},${NOS[b].y}`}
            />
            <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.1;0.85;1" dur={`${5 + (i % 4)}s`} begin={`${i * 0.9}s`} repeatCount="indefinite" />
          </circle>
        ))}
      </Box>
      <Box sx={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(90deg, transparent 0%, transparent 55%, rgba(5,10,18,0.55) 100%)',
      }} />
    </Box>
  );
}